module.exports = "/images/vendor/vue2vis/dist/rightArrow.png?4f88ef172e7bc7e98e24fc7df5a05c4b";